/**
 * Return a string for use in Dromo tooltips shown when a value is updated.
 * @param oldValue - The previous value of the cell
 * @returns A string for use in Dromo cell info messages
 */
export function getUpdatedValueString(oldValue: string): string {
  return `Updated from ${oldValue ? oldValue : 'empty'}`
}
